<template>
	<div ref="wrap" @click="watchPostMessageEvent">
		<div class="exercises-body" v-if="connectFormFlag">
			<div class="exercises-icon">
				<div class="answer-title"></div>
				<span v-if="questionType === 'fillIn'" @click.stop="answerLineFlag = !answerLineFlag" class="answer-unfold">
					<!-- <svg-icon iconClass="unfold" className="delete-icon"></svg-icon> -->
					<iconpark-icon name="Group1576"></iconpark-icon>
				</span>
			</div>
			<div class="exercises-body-title">
				<div class="exercises-body-index">{{ num ? num + '.' : '' }}</div>
				{{ filterBody }}
			</div>
			<div class="exercises-resource">
				<div class="resource-item" v-for="(item, index) in srcResource" :key="index" @click.stop>
					<audio
						class="exercises-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="exercises-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
			<connectLine
				:items="branches"
				:connections="answerDemo"
				@change-connections="event => (answerDemo = event)"
				style="margin-left: 42px;"
			/>
			<!-- @updateParentHeight="updateParentHeight" -->
		</div>

		<div class="exercises-body" v-if="gapFormFlag">
			<div class="exercises-icon">
				<div class="answer-title"></div>
				<span v-if="questionType === 'fillIn'" @click.stop="answerFlag = !answerFlag" class="answer-unfold">
					<!-- <svg-icon iconClass="unfold" className="delete-icon"></svg-icon> -->
					<iconpark-icon name="Group1576"></iconpark-icon>
				</span>
			</div>
			<div _pos="relative" class="exercises-body-title">
				<p class="exercises-body-index" style="top: 17px;">{{ num ? num + '.' : '' }}</p>
				<div class="flex" style="align-items: baseline; flex-wrap: wrap;" v-html="filterBody"></div>
			</div>
			<div class="exercises-resource">
				<div class="resource-item" v-for="(item, index) in srcResource" :key="index" @click.stop>
					<audio
						class="exercises-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="exercises-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
		</div>

		<div class="exercises-body" v-if="moreRadioFormFlag || radioFormFlag">
			<div class="exercises-icon">
				<div class="answer-title"></div>
				<span v-if="questionType === 'fillIn'" @click.stop="answerFlag = !answerFlag" class="answer-unfold">
					<!-- <svg-icon iconClass="unfold" className="delete-icon"></svg-icon> -->
					<iconpark-icon name="Group1576"></iconpark-icon>
				</span>
			</div>
			<div class="exercises-body-title">
				<div class="exercises-body-index">{{ num ? num + '.' : '' }}</div>
				{{ filterBody }}
			</div>
			<div class="exercises-resource">
				<div class="resource-item" v-for="(item, index) in srcResource" :key="index" @click.stop>
					<audio
						class="exercises-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="exercises-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
			<div class="exercises-radio" v-for="(item, index) in branches" :key="index" @click.stop>
				<!-- <div class="radio-box"></div> -->
				<div class="radio-option">{{ numToColNo(index) }}.</div>
				<div class="radio-item" v-html="item"></div>
			</div>
		</div>

		<div
			class="exercises-line"
			style="margin: 13px;"
			v-if="(answerFlag || answerLineFlag) && questionType === 'fillIn'"
		></div>

		<div
			v-if="questionType === 'fillIn-1' && num && (!detailData.is_admin || userType == 0)"
			_flex="~ justify-end"
			_m="x-18px"
		>
			<el-button type="text" style="color: #7c7c7c;" icon="el-icon-edit-outline" @click.stop="open">编辑</el-button>
		</div>
		<div class="exercises-line" _m="x-18px" v-if="questionType === 'fillIn-1'"></div>
		<el-button
			v-if="questionType === 'fillIn-1'"
			type="text"
			style="width: 100px; text-align: left; margin-left: 20px;"
			@click.stop="questionTypeShow"
			>查看答案 <i :class="['el-icon-caret-bottom', 'rotate-icon', (answerFlag || answerLineFlag) && 'rotate-180']"
		/></el-button>

		<div class="exercises-answer" v-show="answerFlag" @click.stop>
			<div class="answer-title">[答案]</div>
			<div class="answer-answer" style="color: #ff5e2a;">{{ answer }}</div>
			<div class="answer-title">[解析]</div>
			<div class="answer-answer">{{ filterExtra }}</div>
			<div class="exercises-resource">
				<div class="resource-item" v-for="(item, index) in extraSrcResource" :key="index">
					<audio
						class="exercises-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="exercises-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
		</div>

		<div class="exercises-answer" v-if="answerLineFlag" @click.stop>
			<div class="answer-title">[答案]</div>
			<connectLine :items="branches" :connections="detailData?.answer" :disabled="true" style="min-width: 820px;" />
			<div class="answer-title">[解析]</div>
			<div class="answer-answer">{{ filterExtra }}</div>
			<div class="exercises-resource">
				<div class="resource-item" v-for="(item, index) in extraSrcResource" :key="index">
					<audio
						class="exercises-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="exercises-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { typeList } from './const.js'
import connectLine from './connectLine.vue'
export default {
	components: {
		connectLine
	},
	watch: {
		detailData: {
			handler(val) {
				if (val?.type) {
					this.subjectTypeChangeEvent(val.type)
				}
			},
			immediate: true,
			deep: true
		},
		answerFlag: {
			handler(val) {
				this.postMessageHeight(val)
			}
		},
		answerLineFlag: {
			handler(val) {
				this.postMessageHeight(val)
			}
		}
	},
	methods: {
		open() {
			let baseURL = `${window.top?.location.origin}`
			let params = new URLSearchParams(window.top?.location.search)
			let token = params.get('token')
			console.log('跳转连接', baseURL, token)
			let uri = `${baseURL}/assets/exam-frontend/#/workbench/abilityList/edit?token=${token}&isJump=${true}&id=${
				this.detailData.id
			}`
			// console.log(uri)
			window.open(`${uri}`)
		},
		watchPostMessageEvent() {
			console.log('iframe被点击')
			window.parent.postMessage(
				{
					code: 'click',
					content: {
						id: this.detailData?.id
					}
				},
				'*'
			)
		},
		valueKeyLabel(e, array) {
			return array.find(item => {
				return item.value === e
			})?.label
		},
		subjectTypeChangeEvent(e) {
			this.text = this.valueKeyLabel(e, typeList)
			switch (e) {
				case '单选题' | 1:
					this.radioFormFlag = true
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
					this.filterExtra = this.filterP(this.detailData.explain)
					this.extraSrcResource = this.filterImg(this.detailData.explain)
					this.answer = `${this.numToColNo(this.detailData.answer)}.${this.filterP(
						this.detailData.branches[this.detailData.answer]
					)}`
					this.branches = this.detailData.branches.map(item => {
						return this.imgRepResource(item)
					})
					this.answerFlag = this.unfold
					break
				case '多选题' | 2:
					this.radioFormFlag = false
					this.moreRadioFormFlag = true
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
					this.filterExtra = this.filterP(this.detailData.explain)
					this.extraSrcResource = this.filterImg(this.detailData.explain)
					this.detailData.answer.forEach(item => {
						this.answer += `${this.numToColNo(item)}.${this.filterP(this.detailData.branches[item])}   `
					})
					this.branches = this.detailData.branches.map(item => {
						return this.imgRepResource(item)
					})
					this.answerFlag = this.unfold
					break
				case '填空题' | 3:
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = true
					this.connectFormFlag = false
					// this.srcResource = this.filterImg(this.detailData.body) //不需要遍历出资源展示
					this.filterBody = this.replaceBody(this.detailData.body)
					// this.filterBody = this.filterP(this.filterBody) //过滤除了p标签之外的其他元素
					this.filterBody = this.imgRepResource(this.filterBody) //把图标换成音频视频标签~傻逼设计
					this.filterExtra = this.filterP(this.detailData.explain)
					this.extraSrcResource = this.filterImg(this.detailData.explain)
					this.detailData.answer.forEach(item => {
						this.answer += `${item}   `
					})
					this.answerFlag = this.unfold
					break
				case '连线题' | 11:
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = true
					this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
					this.filterExtra = this.filterP(this.detailData.explain)
					this.extraSrcResource = this.filterImg(this.detailData.explain)
					this.branches = {
						left: this.detailData.branches.left.map(item => {
							return this.imgRepResource(item)
						}),
						right: this.detailData.branches.right.map(item => {
							return this.imgRepResource(item)
						})
					}
					this.answerLineFlag = this.unfold
					break
			}
			this.$nextTick(() => {
				const videos = document.getElementsByTagName('video')
				for (let i = 0; i < videos.length; i++) {
					let video = videos[i]
					video.addEventListener('loadedmetadata', this.onloadDomMessage)
				}
				const imgs = document.getElementsByTagName('img')
				for (let i = 0; i < imgs.length; i++) {
					let img = imgs[i]
					img.onload = () => {
						this.onloadDomMessage()
					}
				}
			})
			if (!this.filterExtra) this.filterExtra = '无'
			this.postMessageHeight()
		},
		onloadDomMessage() {
			let viewHeight = document.getElementById('app').clientHeight
			if (this.viewHeight == viewHeight) return
			window.parent.postMessage(
				{
					code: 'height',
					content: {
						height: viewHeight,
						id: this.detailData?.id,
						unfold: this.detailData.type == '11' ? this.answerLineFlag : this.answerFlag
					}
				},
				'*'
			)
			this.windowHeight = viewHeight
		},
		questionTypeShow() {
			if (this.detailData.type == 11) {
				this.answerLineFlag = !this.answerLineFlag
			} else {
				this.answerFlag = !this.answerFlag
			}
		},
		postMessageHeight(val = false) {
			this.$nextTick(() => {
				let viewHeight = this.$refs.wrap.clientHeight
				if (viewHeight == this.windowHeight) return
				if (!viewHeight) {
					setTimeout(() => {
						this.postMessageHeight(val)
					}, 100)
					return
				}
				window.parent.postMessage(
					{
						code: 'height',
						content: {
							height: viewHeight,
							id: this.detailData?.id,
							unfold: val
						}
					},
					'*'
				)
				this.windowHeight = viewHeight
			})
		},
		imgRepResource(html) {
			let body = html
			body = body.replaceAll(/<img [^>]*type=['"]([^'"]+)[^>]*>/g, (match, capture) => {
				if (capture === 'video' || capture === 'audio') {
					let item = match.match(/data="([^"]*)"/)[1]
					return `<${capture} style="width:300px" controls src="${item}" controlslist="noplaybackrate nodownload"></${capture}>`
				} else {
					return match
				}
			})
			return body
		},
		replaceBody(html) {
			let body = html
			this.detailData.answer.forEach(item => {
				body = body.replace(/<span (.*?)>(.*?)<\/span>/g, '<p>&nbsp;_____&nbsp;</p>')
			})
			return body
		},
		spans(html) {
			return html.match(/<span (.*?)>(.*?)<\/span>/g)
		},
		numToColNo(num) {
			if (num < 0 || num > 26) {
				return ''
			}
			const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
			return letters.charAt(num)
		},
		filterP(html) {
			let str = ''
			const pLabel = html?.match(/<p>(.*?)<\/p>/g)
			pLabel?.forEach(item => {
				str += item.replace(/<\/?p>/g, '')
			})
			str = str.replace(/<br>(.*?)/g, '')
			return str
		},
		filterImg(html) {
			let arr = []
			const imgLabel = html?.match(/<img [^>]*src=['"]([^'"]+)[^>]*>/g)
			imgLabel?.forEach(item => {
				let src, type
				item.replace(/<img [^>]*data=['"]([^'"]+)[^>]*>/g, (match, capture) => {
					src = capture
				})
				item.replace(/<img [^>]*type=['"]([^'"]+)[^>]*>/g, (match, capture) => {
					type = capture
				})
				arr.push({ src, type })
			})
			return arr
		},
		initPage() {
			window.addEventListener(
				'mousewheel',
				function (event) {
					if (event.ctrlKey === true || event.metaKey) {
						event.preventDefault()
					}
				},
				{ passive: false }
			)
			window.addEventListener(
				'DOMMouseScroll',
				function (event) {
					if (event.ctrlKey === true || event.metaKey) {
						event.preventDefault()
					}
				},
				{ passive: false }
			)
			window.addEventListener(
				'message',
				messageEvent => {
					console.log('iframe通信数据', messageEvent)
					if (
						messageEvent?.data?.type == 'webpackErrors' ||
						messageEvent?.data?.type == 'webpackOk' ||
						messageEvent?.data?.type
					)
						return
					this.questionType = messageEvent?.data?.questionType || 'fillIn'
					this.unfold = messageEvent?.data?.unfold || false
					this.detailData = messageEvent?.data?.content
					this.num = messageEvent?.data?.num
					this.userType = messageEvent?.data?.userType
					// window.removeEventListener('message')
				},
				false
			)
		}
	},
	created() {
		this.initPage()
	},
	mounted() {
		const htmlEl = document.querySelector('html')
		htmlEl.style.overflowY = 'hidden'
		document.body.addEventListener('keydown', e => {
			window.parent.postMessage('deleteElement', '*')
		})
	},
	data() {
		return {
			userType: 0,
			radioFormFlag: false,
			moreRadioFormFlag: false,
			gapFormFlag: false,
			connectFormFlag: false,
			answerFlag: false,
			answerLineFlag: false,
			detailData: {},
			srcResource: [],
			filterBody: '',
			answer: '',
			answerDemo: [],
			extraSrcResource: [],
			filterExtra: '',
			text: '',
			branches: [],
			questionType: 'fillIn',
			windowHeight: null,
			unfold: false,
			num: ''
		}
	}
}
</script>
<style lang="scss" scoped>
.flex {
	display: flex;
}
.exercises-body {
	display: flex;
	flex-direction: column;
	position: relative;
}
.answer-unfold {
	width: 20px;
	height: 20px;
	cursor: pointer;
	text-align: right;
}
.exercises-icon {
	position: absolute;
	top: 20px;
	display: flex;
	justify-content: space-between;
	width: calc(100vw - 40px);
	padding: 0 20px;
	font-size: 16px;
	color: #3e3e3e;
}

.exercises-body-title {
	font-size: 16px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #404040;
	margin-top: 20px;
	margin-bottom: 10px;
	margin-left: 20px;
	padding-left: 22px;
	margin-right: 40px;
	word-break: break-all;
	position: relative;
}
.exercises-body-index {
	position: absolute;
	left: -13px;
	text-align: right;
	width: 31px;
}

.exercises-resource {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	padding-left: 22px;
	.resource-item {
		margin-left: 20px;
		margin-bottom: 20px;
	}
}
.exercises-radio {
	width: 470px;
	max-height: 300px;
	border-radius: 6px 6px 6px 6px;
	display: flex;
	flex-wrap: wrap;
	padding-left: 22px;
	padding-right: 22px;
	margin-left: 20px;
	overflow: auto;
	font-weight: bold;
	color: #404040;
	font-family: PingFang SC-Bold, PingFang SC;
	.radio-box {
		border: 1px solid silver;
		width: 15px;
		height: 15px;
		margin-right: 20px;
	}
	.radio-option {
		margin-right: 10px;
		line-height: 1.8;
	}
	.radio-item {
		flex: 1;
	}
}
.exercises-audio {
	width: 300px;
}

.exercises-answer {
	margin-left: 20px;
	font-size: 15px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	.answer-title {
		color: #757575;
		margin-bottom: 20px;
	}
	.answer-answer {
		color: #3e3e3e;
		margin-bottom: 20px;
	}
}

.exercises-line {
	box-shadow: 0 0 0 1px #cccccc;
	opacity: 0.4;
	display: grid;
}

.rotate-icon {
	transition: transform 0.3s ease-in-out;
}

.rotate-180 {
	transform: rotate(-180deg);
}
</style>
